import CategoryForm from "./Components/CateforyForm/CategoryForm";
import TodoList from "./Components/TodoList/TodoList";
import "./App.css";

function App() {
  return (
    <div className="App">
      <CategoryForm />
      <TodoList />
    </div>
  );
}

export default App;
